module.exports = __webpack_public_path__ + "static/media/Spinner-1s-100px.f2a82970.gif";